import { call, put, all, takeEvery } from "redux-saga/effects";

import { homeActions } from '../slice/homeSlice'
import {
    homeApi,
} from 'services/homeServices'

function* handleGetHomeData() {
    try {
        const res = yield call(homeApi)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(homeActions.getHomeDataSuccess({ data: response.data }))
            }
            else {
                yield put(homeActions.getHomeDataFailed())
            }
        }
        else {
            yield put(homeActions.getHomeDataFailed())
        }
    } catch (error) {
        yield put(homeActions.getHomeDataFailed())
    }
}


export default function* homeSaga() {
    yield all(
        [
            takeEvery(homeActions.getHomeData.type, handleGetHomeData),
        ]
    )
}
